// extracted by mini-css-extract-plugin
export var layoutContainer = "_do-0";
export var layoutContainerNoRounding = "_do-6";
export var layoutContainerOpen = "_do-5";
export var layoutContainerResizing = "_do-1";
export var mainContent = "_do-2";
export var resizeDivider = "_do-3";
export var slidePanel = "_do-4";